import React from "react";

import { planimetriasData as PData } from "./planimetriasData.js";

import background from "./../../../UI/icons/Galerias/background.svg";

import close from "./../../../UI/icons/Galerias/Close.svg";
import next from "./../../../UI/icons/Galerias/next.svg";
import prev from "./../../../UI/icons/Galerias/prev.svg";

interface Props {
  planimetriaOpened: boolean;
  handlePlanimetria: any;
}

interface State {
  ImageArray: any;
  fullGallery: boolean;
  currentImage: any;
  currentImageIndex: number;
}

class Planimetria extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ImageArray: [],
      fullGallery: false,
      currentImage: [],
      currentImageIndex: -1,
    };
  }

  componentDidUpdate(prevProps: any) {
    if(prevProps.planimetriaOpened !== this.props.planimetriaOpened){
    this.handleGetGaleria();
    }
  }

  handleGetGaleria = () => {
      console.log('aqui');
      
    if (PData()) {
      let arrayMixed: any = [];
      PData().forEach((r: any) => {
        arrayMixed.push({
          path: "Planimetria",
          img: r.Imagen,
          nombre: r.Nombre,
        });
      });

      this.setState({ ImageArray: arrayMixed });
    }
  };

  handleGetThumbs = () => {
    return (
      <div className="thumbs-gallery">
        {this.state.ImageArray.map((thumbs: any, index: number) => (
          <div className="gallery-thumb-container" key={index}>
            <img
              className="gallery-thumb"
              alt=""
              src={thumbs.img}
              onClick={() => {
                this.handleOpenGallery(index);
              }}
            />
            <div>{thumbs.nombre}</div>
          </div>
        ))}
      </div>
    );
  };

  handleOpenGallery = (index: number) => {
    this.setState({
      fullGallery: !this.state.fullGallery,
      currentImageIndex: index,
    });
  };

  handleNextImage = () => {
    this.state.currentImageIndex + 1 > this.state.ImageArray.length - 1
      ? this.setState({ currentImageIndex: 0 })
      : this.setState({ currentImageIndex: this.state.currentImageIndex + 1 });
  };

  handlePrevImage = () => {
    this.state.currentImageIndex - 1 < 0
      ? this.setState({ currentImageIndex: this.state.ImageArray.length - 1 })
      : this.setState({ currentImageIndex: this.state.currentImageIndex - 1 });
  };

  render() {
    return (
      <React.Fragment>
        <div
          className={
            this.props.planimetriaOpened
              ? "general-proyecto fade-in"
              : "general-proyecto fade-out"
          }
        >
          <img className="proyectos-background" src={background} />
          <div
            className="close-proyecto"
            onClick={() => {
              this.props.handlePlanimetria('planimetria');
            }}
          >
            <img src={close}></img>
          </div>
          {this.state.ImageArray.length > 0 ? this.handleGetThumbs() : null}
        </div>
        <div
          className={
            this.state.fullGallery
              ? "full-proyecto fade-in"
              : "full-proyecto fade-out"
          }
        >
          <img className="proyectos-background" src={background} />
          <img
            src={
              this.state.ImageArray.length > 0 &&
              this.state.currentImageIndex !== -1
                ? this.state.ImageArray[this.state.currentImageIndex].img
                : ""
            }
            className="proyecto-image"
          ></img>
          <div
            className="close-proyecto"
            onClick={() => {
              this.handleOpenGallery(-1);
            }}
          >
            <img src={close}></img>
          </div>
          {this.state.ImageArray.length > 1 ? (
            <React.Fragment>
              <div
                className="next-proyecto"
                onClick={() => {
                  this.handleNextImage();
                }}
              >
                <img src={next}></img>
              </div>
              <div
                className="previous-proyecto"
                onClick={() => {
                  this.handlePrevImage();
                }}
              >
                <img src={prev}></img>
              </div>
            </React.Fragment>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

export default Planimetria;
